import axios from 'axios'
import Vue from 'vue'
let axiosAccess = axios.create({
    baseURL: 'https://apodaca.rciempaquesplegadizos.com:8180/',
    
    headers: {
        
        'Content-Type': 'application/json',
       
      },
  })
export async function cd74Dia (context,payload){
    try{
    let url = "access/reportemaquina/_cd74_dia"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('dia',payload.dia)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function cd74Semana (context,payload){
    try{
    let url = "access/reportemaquina/_cd74_semana"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('semana',payload.semana)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function cd74Mes (context,payload){
    try{
    let url = "access/reportemaquina/_cd74_mes"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('mes',payload.mes)  
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function cd74Anno (context,payload){
    try{
    let url = "access/reportemaquina/_cd74_anno"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function guillotinaDia (context,payload){
    try{
    let url = "access/reportemaquina/_guillotina_dia"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('dia',payload.dia)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function guillotinaSemana (context,payload){
    try{
    let url = "access/reportemaquina/_guillotina_semana"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('semana',payload.semana)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function guillotinaMes (context,payload){
    try{
    let url = "access/reportemaquina/_guillotina_mes"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('mes',payload.mes)  
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function guillotinaAnno (context,payload){
    try{
    let url = "access/reportemaquina/_guillotina_anno"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
 
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bobst106Dia (context,payload){
    try{
    let url = "access/reportemaquina/_bobst106_dia"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('dia',payload.dia)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bobst106Semana (context,payload){
    try{
    let url = "access/reportemaquina/_bobst106_semana"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('semana',payload.semana)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bobst106Mes (context,payload){
    try{
    let url = "access/reportemaquina/_bobst106_mes"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('mes',payload.mes)  
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bobst106Anno (context,payload){
    try{
    let url = "access/reportemaquina/_bobst106_anno"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
   
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bittroqueladora3Dia (context,payload){
    try{
    let url = "access/reportemaquina/_bittroqueladora3_dia"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('dia',payload.dia)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bittroqueladora3Semana (context,payload){
    try{
    let url = "access/reportemaquina/_bittroqueladora3_semana"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('semana',payload.semana)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bittroqueladora3Mes (context,payload){
    try{
    let url = "access/reportemaquina/_bittroqueladora3_mes"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('mes',payload.mes)  
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bittroqueladora3Anno (context,payload){
    try{
    let url = "access/reportemaquina/_bittroqueladora3_anno"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
 
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bittroqueladoran1Dia (context,payload){
    try{
    let url = "access/reportemaquina/_bittroqueladoran1_dia"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('dia',payload.dia)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bittroqueladoran1Semana (context,payload){
    try{
    let url = "access/reportemaquina/_bittroqueladoran1_semana"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('semana',payload.semana)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bittroqueladoran1Mes (context,payload){
    try{
    let url = "access/reportemaquina/_bittroqueladoran1_mes"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('mes',payload.mes)  
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bittroqueladoran1Anno (context,payload){
    try{
    let url = "access/reportemaquina/_bittroqueladoran1_Anno"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bitpegadoraDia (context,payload){
    try{
    let url = "access/reportemaquina/_bitpegadora_dia"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('dia',payload.dia)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bitpegadoraSemana (context,payload){
    try{
    let url = "access/reportemaquina/_bitpegadora_semana"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('semana',payload.semana)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bitpegadoraMes (context,payload){
    try{
    let url = "access/reportemaquina/_bitpegadora_mes"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('mes',payload.mes)  
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function bitpegadoraAnno (context,payload){
    try{
    let url = "access/reportemaquina/_bitpegadora_anno"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
     
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function cierreordenfabricacionDia (context,payload){
    try{
    let url = "access/reportemaquina/_cierreordenfabricacion_dia"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('dia',payload.dia)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function cierreordenfabricacionSemana (context,payload){
    try{
    let url = "access/reportemaquina/_cierreordenfabricacion_semana"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('semana',payload.semana)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function cierreordenfabricacionMes (context,payload){
    try{
    let url = "access/reportemaquina/_cierreordenfabricacion_mes"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('mes',payload.mes)  
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function cierreordenfabricacionAnno (context,payload){
    try{
    let url = "access/reportemaquina/_cierreordenfabricacion_anno"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    
    values.append('anno',payload.anno)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}